<div class="checkbox-container" [class.focused]="focused" [class.disabled]="disabled">
  <div class="checkbox-wrapper" (click)="onToggle()">
    <div
      class="checkbox"
      [class.checked]="checked"
      [class.indeterminate]="indeterminate"
      [class.hover]="!disabled"
      (focus)="onFocus()"
      (blur)="onBlur()"
      tabindex="0"
      role="checkbox"
      [attr.aria-checked]="checked"
      [attr.aria-disabled]="disabled"
    >
      <svg
        *ngIf="checked && !indeterminate"
        xmlns="http://www.w3.org/2000/svg"
        width="12"
        height="12"
        viewBox="0 0 12 12"
        fill="none"
      >
        <path
          d="M10 3L4.5 8.5L2 6"
          stroke="currentColor"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
      <svg
        *ngIf="indeterminate"
        xmlns="http://www.w3.org/2000/svg"
        width="12"
        height="12"
        viewBox="0 0 12 12"
        fill="none"
      >
        <path
          d="M3 6H9"
          stroke="currentColor"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </div>
    <label class="label" *ngIf="label">{{ label }}</label>
  </div>
</div>
